import React from 'react'
import { useNavigate } from 'react-router-dom'

import "./gas.css"

export default function Gas() {
  const navigate = useNavigate()
  return (
    <div className='emas__gas'>
        <div className='emas__gas-header'>
            <div>
                <h1>The Western Australian Gas Market</h1>
            </div>
            <div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Euismod nisi porta lorem mollis aliquam ut porttitor leo. Dolor sit amet consectetur adipiscing elit. In ornare quam viverra orci sagittis eu volutpat odio.</p>
            </div>
            <div>
              <button onClick={() => navigate("../Contact-Us")}>Looking for a quote?</button>
            </div>
        </div>
    </div>
  )
}
